import React, { useState, useContext, useEffect } from 'react';
import type { Toast } from '@/types/components/common/toast';
import { ToastContext } from './context';
import { ToastItem } from './ToastItem';

export const ToastContainer: React.FC = () => {
    const context = useContext(ToastContext);
    const [toasts, setToasts] = useState<Toast[]>([]);

    useEffect(() => {
        if (context) {
            context.addToast = (newToast) => {
                const id = Math.random().toString(36).substring(2, 9);
                const toast = { ...newToast, id };

                setToasts((prev) => [...prev, toast]);

                if (newToast.duration !== Infinity) {
                    setTimeout(() => {
                        context.removeToast(id);
                    }, newToast.duration || 5000);
                }
            };

            context.removeToast = (id) => {
                setToasts((prev) => prev.filter((toast) => toast.id !== id));
            };
        }
    }, [context]);

    if (!toasts.length) return null;

    return (
        <div
            className="fixed top-4 right-4 z-50 flex flex-col gap-3"
            aria-live="polite"
        >
            {toasts.map((toast) => (
                <ToastItem
                    key={toast.id}
                    {...toast}
                    onRemove={context?.removeToast ?? (() => {})}
                />
            ))}
        </div>
    );
};